import * as marietta from '../../..';
import * as marietta3d from '../../../../marietta3d';
import { ModelLoadSystem } from '../../../view3d/webcad/WebCad3dModelLoadSystem';

// Menu to choose various designs in exterior
export default class InnerDesignOptionMenu {
  data: marietta3d.AutoGen.ConstructionModel;

  viewObj: HTMLElement;

  /**
   * コンストラクタ
   */
  constructor() {
    this.viewObj = document.getElementById('tabInnerDesignOptions');

    // 情報をGET
    this.data = marietta.webcad.WebCADGlobal.autoMain.Model;
    document.getElementById('btnChangeInnerDesignOption').addEventListener('click', this.okBtnEventHandler);
    document.getElementById('btnCancelInnerDesignOption').addEventListener('click', () => {
      this.init();
      marietta.webcad.WebCADGlobal.itemChangeMenuCategories3d.reset();
    });
  }

  /**
   * 初期設定
   */
  init = () => {
    console.log('init');

    // 設定されている値を適用
    console.log(marietta.webcad.WebCADGlobal.autoMain.Model);

    // パラメータの表示を更新
    this.updateParam();
  };

  /**
   * キャンセルボタンが押された
   */
  cancelBtnEventHandler = () => {
    this.init();
  };

  /**
   * OKボタンが押された
   */
  okBtnEventHandler = () => {
    // [3D] ConstructionModelに反映
    marietta.webcad.WebCADGlobal.showBusy(marietta.webcad.collection.WebCADMessages.getText('BUSY_PREPARING_DATA'), () => {
      setTimeout(() => {
        this.setParamConstructionModel();
      }, 500);
    });
  };

  /**
   * タブに表示するパラメータを更新
   */
  updateParam() {
    if (!this.data) return;

    console.log('updateParam');
    console.log(this.data);

    // 照明
    // this.setSelectioToView('inner_design_lighting', this.data.Option.lighting.toString());

    // 折り上げ天井
    this.setSelectioToView('inner_design_oriage', this.data.Option.oriage.toString());
  }

  /**
   * タブに表示するパラメータを更新
   */
  setSelectioToView = (selectionName: string, value: string): void => {
    // eslint-disable-next-line no-undef
    const elements: NodeListOf<HTMLElement> = document.getElementsByName(selectionName);

    switch (selectionName) {
      case 'inner_design_oriage':
        elements[0].removeAttribute('checked');
        (elements[0] as HTMLInputElement).checked = false;
        if (value === '1') {
          elements[0].setAttribute('checked', 'checked');
          (elements[0] as HTMLInputElement).checked = true;
        }
        break;
      default:
        for (let i: number = 0; i < elements.length; i += 1) {
          if ((elements[i] as HTMLInputElement).value === value) {
            elements[i].setAttribute('checked', 'checked');
            (elements[i] as HTMLInputElement).checked = true;
          } else {
            elements[i].removeAttribute('checked');
            (elements[i] as HTMLInputElement).checked = false;
          }
        }
        break;
    }
  };

  /**
   * [3D] ConstructionModelに反映
   */
  setParamConstructionModel = () => {
    // チェックボックス類
    this.data.Option.oriage = this.getCheckboxStatus('inner_design_oriage');
    // this.data.Option.lighting = this.getSelectedRadioButton('inner_design_lighting');

    // 3Dのボタンの表示をデフォルトに戻す
    marietta.webcad.WebCADGlobal.init3dMenu();

    // save camera state
    marietta.view3d.webcad.View3dGlobal.shared.saveCameraState();
    // keep camera state
    marietta.view3d.webcad.View3dGlobal.shared.keepCameraState = true;
    new ModelLoadSystem().request3D();
    // [2D] modelParamに反映
    this.setModelParamJson();

    // setが完了したらダイアログを閉じる
    marietta.webcad.WebCADGlobal.itemChangeMenuCategories3d.reset();
  };

  /**
   * ラジオボタンの選択されている
   * */
  getSelectedRadioButton = (key: string): number => {
    // eslint-disable-next-line no-undef
    const elements: NodeListOf<HTMLElement> = document.getElementsByName(key);
    for (let i: number = 0; i < elements.length; i += 1) {
      console.log((elements[i] as HTMLInputElement).getAttribute('checked'));

      if ((elements[i] as HTMLInputElement).checked) {
        return parseInt((elements[i] as HTMLInputElement).value, 10);
      }
    }
    return null;
  };

  /**
   * チェックボックスの状態の取得
   * */
  getCheckboxStatus = (key: string): number => {
    // eslint-disable-next-line no-undef
    const elements: NodeListOf<HTMLElement> = document.getElementsByName(key);
    if ((elements[0] as HTMLInputElement).checked) {
      return 1;
    }
    return 0;
  };

  /**
   * [2D] modelParamに反映
   */
  setModelParamJson() {
    const jsonData = this.data.writeJSON();
    marietta.webcad.WebCADGlobal.setModelParamFromConstructionModel(jsonData);
  }
}
